import shortid from 'shortid'
import { TrackItem, TrackSegment } from '../types'

export const TRACK_PREFIX = 'TRACK_ITEM_'
export const SEGMENT_PREFIX = 'TRACK_SEGMENT_'

export function generateTrackItemId(): TrackItem['id'] {
  return `${TRACK_PREFIX}${shortid.generate()}`
}
export function generateTrackSegmentId(): TrackSegment['id'] {
  return `${SEGMENT_PREFIX}${shortid.generate()}`
}
